import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { replace } from "connected-react-router";
import { withRouter, Link } from "react-router-dom";

import AuthenticationActioner from "services/authentication/actioner";
import UserUtils from "services/user/utils";

import Button from "components/Button";
import Checkbox from "components/Checkbox";
import TextField from "components/TextField";

import ParkkiTheme from "themes/ParkkiTheme";

import Loader from "react-loaders";
import { SSOLoginModal } from "../SSOLayout";
import { Grid } from "@mui/material";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  inputContainer: {
    width: "100%",
  },
  textFieldContainer: {
    marginBottom: "16px",
  },
  forgotPasswordContainer: {
    flex: 1,
    textAlign: "right",
    color: "white",
    opacity: "0.85",
    cursor: "pointer",
    textDecoration: "none",
  },
  keepLoggedInContainer: {
    flex: 1,
    marginTop: `-${ParkkiTheme.spacings.muiDefault}`,
  },
  checkboxLabel: {
    color: "white",
    opacity: "0.85",
    fontSize: "16px",
  },
};

class LoginForm extends React.Component {
  initialState = {
    username: "",
    password: "",
    error: {
      username: "",
      password: "",
    },
    keepLoggedIn: false,
    loading: false,
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  login = (event) => {
    event.preventDefault();

    const { replace } = this.props;

    if (!UserUtils.isEmailValid(this.state.username)) {
      this.setState({
        error: { ...this.state.error, username: "Email invalide" },
      });
      return;
    }
    if (!this.hasPassword(this.state.password)) {
      this.setState({
        error: { ...this.state.error, password: "Mot de passe obligatoire" },
      });
      return;
    }

    this.setState(
      {
        error: {
          username: "",
          password: "",
        },
        loading: true,
      },
      () => {
        this.props
          .setAuthFromCredentials({
            username: this.state.username,
            password: this.state.password,
            keepLoggedIn: this.state.keepLoggedIn,
          })
          .then((user) => replace(UserUtils.getDefaultRoute(user)))
          .catch((err) => {
            this.setState({
              ...this.initialState,
              username: this.state.username,
            });
          });
      }
    );
  };

  hasPassword = (password) => {
    return get(password, "length", 0) > 1;
  };

  handleKeyPressed = (ev) => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      this.login();
    }
  };

  render() {
    const { intl } = this.props;

    if (this.state.loading) {
      return (
        <div style={styles.container}>
          <Loader style={{ marginTop: "24px" }} type="ball-beat" />
        </div>
      );
    }

    return (
      <div style={styles.container}>
        <form onSubmit={this.login} style={styles.inputContainer}>
          <div style={styles.textFieldContainer}>
            <TextField
              label={intl.messages["loginScene.login.userNameEmail"]}
              onChange={(e) => this.setState({ username: e.target.value })}
              error={this.state.error.username !== ""}
              helperText={this.state.error.username}
              value={this.state.username}
              fullWidth
              onKeyPress={this.handleKeyPressed}
            />
          </div>

          <div style={styles.textFieldContainer}>
            <TextField
              label={intl.messages["loginScene.login.password"]}
              onChange={(e) => this.setState({ password: e.target.value })}
              error={this.state.error.password !== ""}
              helperText={this.state.error.password}
              value={this.state.password}
              type="password"
              fullWidth
              onKeyPress={this.handleKeyPressed}
            />
          </div>
          <Button
            type="submit"
            label={intl.messages["loginScene.login.buttonLabel"]}
            onClick={this.login}
          />
        </form>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "12px",
            width: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <div style={styles.keepLoggedInContainer}>
                <Checkbox
                  checked={this.state.keepLoggedIn}
                  label={intl.messages["loginScene.login.keepLoggedIn"]}
                  onChange={() =>
                    this.setState({ keepLoggedIn: !this.state.keepLoggedIn })
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} md={6} textAlign={"right"}>
              <Link
                to="/forgot-password"
                style={styles.forgotPasswordContainer}
              >
                {intl.messages["loginScene.login.forgotPassword"]}
              </Link>
            </Grid>
          </Grid>
        </div>
        <SSOLoginModal />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setAuthFromCredentials: (creds) =>
    dispatch(AuthenticationActioner.setAuthFromCredentials(creds)),
  replace: (route) => dispatch(replace(route)),
});

LoginForm.defaultProps = {};

LoginForm.propTypes = {
  setAuthFromCredentials: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, mapDispatchToProps)(injectIntl(LoginForm))
);
